import React, { lazy,Suspense, useEffect } from "react";
import classNames from "classnames";
import styles from "./App.module.scss";
import {
  Route, //路由
  BrowserRouter as Router, //所有的dom都包含在Router(根节点)
  Switch, //处理无匹配路由
} from "react-router-dom";
import { Spin } from "antd";
import {YakitLogin} from "@/pages/YakitLogin/YakitLogin"

const AdminPage = lazy(() => import("@/admin/index"));
const DownloadData = lazy(() => import("@/pages/DownloadData/DownloadData"));
const Other = lazy(() => import("@/components/Other"));

interface AppProps {}

const App: React.FC<AppProps> = (props) => {
  // react-router-dom后退不刷新解决方法
  useEffect(() => {
    // const handlePopstate = () => {
    //   window.location.reload();
    // };
    // window.addEventListener('popstate', handlePopstate);
    // return () => {
    //   window.removeEventListener('popstate', handlePopstate);
    // };
  }, []);
  return (
    <Suspense
      fallback={
        <Spin spinning style={{ margin: "0 auto", display: "block" }} />
      }
    >
      <div className={classNames(styles["app"])}>
        <Router>
          <Switch>
            <Route path="/" exact component={YakitLogin}></Route>
            <Route path="/download" exact component={DownloadData}></Route>
            <Route path="/admin/" component={AdminPage}></Route>
            <Route component={Other}></Route>
          </Switch>
        </Router>
      </div>
    </Suspense>
  );
};

export default App;
